module.exports = __webpack_public_path__ + "media/images/emblems/Othmarsingen-blason-1e04e8ee6e99f9e70f35a83d5086fe58.png";